import { render, staticRenderFns } from "./VisualizzaDocumento.vue?vue&type=template&id=12ca6347&scoped=true&"
import script from "./VisualizzaDocumento.vue?vue&type=script&lang=js&"
export * from "./VisualizzaDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ca6347",
  null
  
)

export default component.exports